import React, { Fragment } from 'react';
import { NavLink } from 'redux-first-router-link';
import './authorBiosStyle.scss';
import MetaTags from '../../common/MetaTags';
import { getHighResolutionAuthorImage } from './utils';
import {
  getFileName, isValid, isText, trimmed, decodeTags, makeAuthorImgLink,
} from '../../../utils';
import { AUTHOR_IMAGE_PLACEHOLDER } from '../../../consts';

const SecondaryAuthorBio = ({
  secondaryAuthor,
  isMobile,
}) => {
  let secondAuthorImg = isValid(secondaryAuthor.image) ? secondaryAuthor.image : AUTHOR_IMAGE_PLACEHOLDER;
  secondAuthorImg = (secondAuthorImg !== AUTHOR_IMAGE_PLACEHOLDER) ? getHighResolutionAuthorImage(makeAuthorImgLink(secondAuthorImg)) : secondAuthorImg;
  const secondAuthorUrl = isValid(secondaryAuthor.link) ? `/author/${secondaryAuthor.link}` : null;
  const secondAuthorTitle = isValid(secondaryAuthor.title) ? secondaryAuthor.title : 'Title Placeholder';
  const secondAuthorName = isValid(secondaryAuthor.name) ? secondaryAuthor.name : null;
  const secondAuthorBio = isValid(secondaryAuthor.description) ? decodeTags(secondaryAuthor.description) : null;
  const className = 'bio-article';

  return (
        <>
            <div className="author-content-article">
                <div className={className}>
                  <div className="author-img-container">
                      {isMobile && <img className="top-card-img-mobile" src={secondAuthorImg} alt={getFileName(secondAuthorImg)} loading="lazy" />}
                      {!isMobile && <img className="top-card-img-nonmobile" src={secondAuthorImg} alt={getFileName(secondAuthorImg)} loading="lazy" />}
                  </div>
                  <div className='author-card'>
                      <h3 className='author-name'><NavLink to={secondAuthorUrl} target="_blank">{secondAuthorName}</NavLink></h3>
                      <h3 className='author-title'>{secondAuthorTitle}</h3>
                      <div className='author-bio' dangerouslySetInnerHTML={{ __html: secondAuthorBio }}></div>
                      <div className='full-bio-link'><NavLink to={secondAuthorUrl} target="_blank">read full bio</NavLink></div>
                  </div>
                </div>
            </div>
        </>
  );
};

export default SecondaryAuthorBio;
